import React from "react";
import PropTypes from "prop-types";
import CharacterNavItem from "./CharacterNavItem";
import Button from "wonderbly-components/lib/Button";
import cx from "classnames";
import CharacterThumbnail from "./CharacterThumbnail";
import Modal from "../../Modal";
import { replaceTextWithValues } from "src/common/utils/text-replace";

const CharacterNav = (props) => (
  <div
    className={cx("character-picker-nav", {
      "character-picker-nav--open": props.isPickerOpen,
      "character-picker-nav--page-active": props.isPageActive,
    })}
  >
    <Button
      className="character-picker-label"
      onClick={props.onClickLetter}
      unstyled
    >
      <div className="character-picker-letter">{props.letter}</div>
      <CharacterThumbnail
        src={props.selectedCharacter.thumbnail}
        alt={props.selectedCharacter.character}
      />
    </Button>
    {props.isChangeable && (
      <Modal
        bypass={!props.isModal || !props.isPickerOpen}
        className="character-picker-modal"
        isOpen
      >
        <div className="character-picker-wrapper">
          {props.isPickerOpen ? (
            [
              <div
                className="character-picker-characters"
                key="character-picker-characters"
              >
                <p className="character-picker-description">
                  {replaceTextWithValues(
                    props.prismicContent.selectDescription,
                    { letter: props.letter }
                  )}
                </p>
                <div className="rule--medium" />
                {props.characters.map((char, index) => (
                  <CharacterNavItem
                    key={index}
                    index={index}
                    character={char}
                    characterIndex={props.characterIndex}
                    onChangeCharacter={props.onChangeCharacter}
                    values={props.values.character_selection}
                    select={props.prismicContent.selectCta}
                    inUse={props.prismicContent.selectInUse}
                  />
                ))}
              </div>,
              <Button
                onClick={props.onClickCancel}
                fullWidth
                className="character-picker-cancel"
                key="character-picker-cancel"
              >
                {props.prismicContent.cancelCta}
              </Button>,
            ]
          ) : (
            <Button onClick={props.onClickChange}>
              {props.prismicContent.changeCta}
            </Button>
          )}
        </div>
      </Modal>
    )}
  </div>
);

CharacterNav.propTypes = {
  isModal: PropTypes.bool.isRequired,
  onClickLetter: PropTypes.func.isRequired,
  letter: PropTypes.string.isRequired,
  selectedCharacter: PropTypes.shape({
    thumbnail: PropTypes.string.isRequired,
    character: PropTypes.string.isRequired,
  }),
  isChangeable: PropTypes.bool.isRequired,
  isPickerOpen: PropTypes.bool.isRequired,
  isPageActive: PropTypes.bool.isRequired,
  characters: PropTypes.array.isRequired,
  characterIndex: PropTypes.number.isRequired,
  onChangeCharacter: PropTypes.func.isRequired,
  onClickChange: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  prismicContent: PropTypes.shape({
    selectDescription: PropTypes.string,
    cancelCta: PropTypes.string,
    changeCta: PropTypes.string,
    selectCta: PropTypes.string,
    selectInUse: PropTypes.string,
  }).isRequired,
  onClickCancel: PropTypes.func.isRequired,
};

export default CharacterNav;
